import * as THREE from 'three'

import MathsUtils from '@/utils/mathsUtils'
import EditingArrow from '@glass-designer/objects/editingArrow'
import BaseObject from './baseObject'
import EditorTypes from '../types'


// Editing Rotate Handle
// A rotate handle object in the scene to display handles for the user interaction
export default class EditingRotateHandle extends BaseObject {
  constructor(editor, options = {}) {
    super(editor)

    this.size = options.size || 22
    this.colour = options.colour || '#FFFFFF'
    this.hoverColour = options.hoverColour || '#808080'

    this.gridSnapDisabled = !!options.gridSnapDisabled

    this.position = new THREE.Vector2(0, 0)
    this.moveLastPoint = new THREE.Vector2(0, 0)
    
    this.listenMouseEvents = true

    this.sceneObject = new THREE.Object3D()
    this.updateSceneObject()

    this.rotateArrow = new EditingArrow(this.editor, {
      colour: this.colour,
      hoverColour: this.hoverColour,
      arrowTexture: editor.resources.arrowTextureRotate
    })
    this.rotateArrow.setRotation(90)
    this.rotateArrow.setObjectEventListener(this)
    this.addChildObject(this.rotateArrow)
  }

  // onBeforeRender
  // Called prior to rendering of the object
  onBeforeRender() {
    super.onBeforeRender()
  }


  // Update the position of the handle
  setPosition(pos) {
    this.position.set(pos.x, pos.y)
    this.rotateArrow.setPosition(pos)
  }

  // Update the angle of the rotate handle
  // In degrees
  setRotation(angle) {
    this.rotateArrow.setRotation(angle)
  }


  /**
   * Build the initial drawing objects to display the editing line
   */
  updateSceneObject() {
    this.clearSceneObject()

  }


  clear() {
    
  }

  /**
   * Receive an object event from objects we're listening too
   */
  onReceiveObjectEvent(object, eventType, data) {
    if(object == this.rotateArrow) {
      if(data.position)
        this.setPosition(data.position)

      // Bubble up events
      this.sendObjectEvent(eventType, data)
    }
  }

}
